import { FC, MouseEvent, useState } from "react";
import { Box, List, Menu, MenuItem } from "@mui/material";
import ChallengeListItem from "./ChallengeListItem";
import { useGameDataContext } from "@context/GameDataContext";
import { useSelectedChallengeContext } from "@context/SelectedChallengeContext";
import { Challenge } from "@/models/pdfData";
import { sortChallenges } from "@/utils/challenge-utils";

const ChallengeList: FC<{
  onChallengeSelect?: (challenge: Challenge) => void;
}> = ({ onChallengeSelect }) => {
  const { game, restoreChallenge } = useGameDataContext();
  const { loadChallenge, challenge } = useSelectedChallengeContext();

  const [contextMenu, setContextMenu] = useState<{
    mouseX: number;
    mouseY: number;
    challengeId: string;
  } | null>(null);

  const handleOnChallengeSelect = (challenge: Challenge) => {
    loadChallenge(challenge);
    if (onChallengeSelect) {
      onChallengeSelect(challenge);
    }
  };

  const handleContextMenu = (event: MouseEvent, challengeId: string) => {
    event.preventDefault();
    setContextMenu(
      contextMenu === null
        ? {
            mouseX: event.clientX + 2,
            mouseY: event.clientY - 6,
            challengeId,
          }
        : null,
    );
  };

  const handleRestore = (challengeId: string) => {
    restoreChallenge(challengeId);
    handleClose();
  };

  const handleClose = () => {
    setContextMenu(null);
  };
  return (
    <Box pt={3} maxHeight={"100%"} height={"100%"} boxSizing={"border-box"}>
      <Box sx={{ overflow: "auto", maxHeight: "100%" }}>
        <Menu
          open={contextMenu !== null}
          onClose={handleClose}
          anchorReference="anchorPosition"
          anchorPosition={
            contextMenu !== null
              ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
              : undefined
          }
        >
          <MenuItem
            onClick={() =>
              contextMenu?.challengeId &&
              handleRestore(contextMenu?.challengeId)
            }
          >
            Wiederherstellen
          </MenuItem>
        </Menu>
        <List>
          {game &&
            sortChallenges(game?.challenges).map((challengeItem: Challenge) => {
              return (
                <ChallengeListItem
                  key={`challenge-list-item-${challengeItem.id}`}
                  challenge={challengeItem}
                  selected={challengeItem.id === challenge.id}
                  onClick={handleOnChallengeSelect}
                  handleContextMenu={(event, challengeItem) =>
                    handleContextMenu(event, challengeItem.id)
                  }
                  teamIconUrls={{
                    team1: game?.gameData?.team1?.iconUrl,
                    team2: game?.gameData?.team2?.iconUrl,
                  }}
                />
              );
            })}
        </List>
      </Box>
    </Box>
  );
};

export default ChallengeList;
